/**
 * The brand splash belongs to the first app load only. Module scope keeps the
 * flag when a startup gate (terms/update/error) unmounts and remounts the
 * bootstrap route.
 */
let splashCompleted = false

export function hasSplashCompleted(): boolean {
  return splashCompleted
}

export function markSplashCompleted(): void {
  splashCompleted = true
}
